import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { configuration } from 'src/app/configuration';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from 'src/app/core/services/app.service';
import { Router } from '@angular/router';
import { ExcelService } from 'src/app/core/services/excel.service';
import { Title } from '@angular/platform-browser';
import { LocalStorageService } from 'ngx-webstorage';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { _CampagneService } from '../campagne-module.service'
import { FormGroup, FormBuilder } from '@angular/forms';
import { SuiviEiaService } from '../suivi-eia/data-access/suivi-eia.service';
import swal from "sweetalert2";

const API_URL = configuration.apiUrl;
const FILE_URL = configuration.fileUrl;

@Component({
  selector: 'app-suivi',
  templateUrl: './suivi.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .dark-modal .modal-content {
      background-color: #292b2c;
      color: white;
    }
    .dark-modal .close {
      color: white;
    }
    .light-blue-backdrop {
      background-color: #5cb3fd;
    }
`]
})

export class SuiviComponent implements OnInit {

  public ICpage: any
  public AMpage: any
  public OEpage: any

  public response: any = [];
  public listIC: any = [];
  public listAM: any = [];
  public listOE: any = [];
  public transformedSuivi: any = [];

  public _direction: any
  public _structure: any
  public _classification: any
  public nom_prenoms: string
  public matricule: string
  public campagne_id: any

  public listDR: any = [];
  public listStructure: any = [];
  public listClassification: any = [];

  public isLoading: boolean = false;
  public myForm: FormGroup;

  public agentRow: any;
  public offset: any;
  public totalPage: 0;
  public totalRecords: 0;
  public recordsPerPage: 0;
  public p = 1;

  public activeTab: any;
  public activeId: any = 1;

  public loaderText: string;
  public listSuivi: any = [];
  public key = 'matricule';
  public reverse = false;
  public filter: string;
  public statutFiche: any;
  public structureDataLoaded = false;
  public classificationDataLoaded = false;
  public directionDataLoaded = false;

  public bodyObject: any = {
    title: 'Gestion des opérations',
    columns: [
      { "field": "matricule", "header": "Mle", "isText": true },
      { "field": "qualite", "header": "Nom & Prénoms", "isText": true },
      { "field": "poste.code", "header": "Poste", "isText": true },
      { "field": "direction.code", "header": "Direction", "isText": true },
      { "field": "structure.code", "header": "Structure", "isText": true },
      { "field": "classification.code", "header": "Class.", "isText": true },
      { "field": "category.code", "header": "Cat.", "isText": true },
      { "field": "anciennete_poste", "header": "Anc. au poste.", "isText": true },
      { "field": "anciennete_sir", "header": "Anc.sir.", "isText": true },
      { "field": "anciennete_cat", "header": "Anc.cat..", "isText": true },
      { "field": "age", "header": "Age", "isText": true, },
      { "field": "statut", "header": "Statut", "isBadge": true, },
      // { "field": "raccourcis", "header": "Raccourcis", "isActions": true },
    ]
  };

  constructor(
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    private loadingBar: LoadingBarService,
    private appService: AppService,
    private _router: Router,
    private excelService: ExcelService,
    private title: Title,
    private storage: LocalStorageService,
    private toastrService: ToastrService,
    private campagneSce: _CampagneService,
    private suiviSce: SuiviEiaService,
    private fb: FormBuilder,
  ) { }

  public async exportXls(): Promise<void> {
    this.isLoading = true;
    this.toastrService.info('La génération de l\'export est en cours');

    const data = {'campagne_id': this.storage.retrieve('idCampagneEiaSelected')};

    try {
      const res = await this.appService.postData(`capital-humain/agents/export-campagne/all`, data).toPromise();

      if (res?.data) {
        const exportData = res.data.map(e => ({
          'Mle': e.matricule,
          'Nom & Prénoms': `${e.qualite} ${e.nom} ${e.prenoms}`,
          'Poste': e.poste?.libelle,
          'Structure': e.structure?.code,
          'Cat.': e.category?.code,
          'Anc.au poste': e.anciennete_poste,
          'Anc.sir': e.anciennete_sir,
          'Anc.cat.': e.anciennete_cat,
          'Age': e.age,
          'Statut': this.getDisplayStatut(e.statut)
        }));

        this.excelService.exportAsExcelFile(exportData, 'Liste des agents pour le suivi évaluation');
      } else {
        this.toastrService.warning('Aucune donnée à exporter');
      }
    } catch (error) {
      this.toastrService.error(error.error.message || 'Une erreur est survenue lors de l\'export');
    } finally {;
      this.isLoading = false;
    }
  }

  ngOnInit() {
    this.title.setTitle('Suivi EIA | HR Performance');
    this.pageCallback();
  }


  onDropdownClick(type: 'classification' | 'direction') {
    switch (type) {
      case 'classification':
        if (!this.classificationDataLoaded) {
          this.campagneSce.getAllClassification({}).subscribe((res) => {
            this.listClassification = res.data;
            this.classificationDataLoaded = true;
          });
        }
        break;
      case 'direction':
        if (!this.directionDataLoaded) {
          this.campagneSce.getAllDirection({}).subscribe((res) => {
            this.listDR = res.data;
            this.directionDataLoaded = true;
          });
        }
        break;
    }
  }


  public getCellValue(field: string, agent: any): string {
    if (!field) return '';
    const fieldParts = field.split('.');
    let value = agent;
    for (const part of fieldParts) {
      value = value ? value[part] : '';
    }
    return value;
  }

  public getStatusClasses(statut: string): { [key: string]: boolean } {
    return {
      'badge-warning': statut === 'attente',
      'badge-effectue': statut === 'effectué',
      'badge-accepte': statut === 'accepté',
      'badge-planifie': statut === 'planifié',
      'badge-valide': statut === 'validé',
      'badge-approuve': statut === 'approuvé',
      'badge-revus': statut === 'revu',
      'badge-soumis': statut === 'soumis',
      'badge-success': statut === 'démarré',
      'badge-100': statut !== 'planifié'
    };
  }

  public getDisplayStatut(statut: string): string {
    return statut === 'en attente' ? statut : `${statut}e`;
  }

  // Post all FILTER
  public filtr(): void {
    this.pageCallback();
  }

  public pageCallback(): void {
    const data = {
      direction_id: this._direction?.id,
      structure: this._structure?.code,
      classification: this._classification?.code,
      nom_prenoms: this.nom_prenoms,
      matricule: this.matricule,
      campagne_id: this.storage.retrieve('idCampagneEiaSelected'),
    }
    this.loadingBar.start();
    this.appService.postData(`capital-humain/agents/agents-for-suivi-evaluation?page=${this.p}`, data)
      .subscribe({
        next: (res: any) => {
          this.loadingBar.stop();
          this.response = res.data;
          this.listIC = res.data['IC'].data;
          this.ICpage = res.data['IC'];
          this.listAM = res.data['AM'].data;
          this.AMpage = res.data['AM'];
          this.listOE = res.data['OE'].data;
          this.OEpage = res.data['OE'];

          const newArray = [this.listIC, this.listAM, this.listOE];
          this.transformedSuivi = newArray.reduce((r, a) => r.concat(a), []);
          // this.toastrService.success(res.message);
        },
        error: (error) => {
          this.loadingBar.stop();
          this.toastrService.error(error.error.message);
        }
      })
  }

  public onPageChange(event) {
    this.p = event;
    this.pageCallback()
  }

  // Get all STRUCTURE
  public getStructure(direction_id): void {
    this.campagneSce.getAllStructureById(direction_id)
      .subscribe({
        next: (response) => {
          this.loadingBar.stop();
          this.listStructure = response['data'];
        },
        error: (error) => {
          this.loadingBar.stop();
          this.toastrService.error(error.error.message);
        }
      })
  }

  public onChangeItem(item: any, type: string,) {
    if (type === 'direction') {
      this.getStructure(item.value.id)
      this.listStructure = []
    } else if (type === 'structure') {
      return;
    } else {
      return;
    }
  }

  public onClearItem(type: string) {
    if (type === 'direction') {
      this.listStructure = [];
    } else if (type === 'structure') {
      return;
    } else {
      return;
    }
  }

  public clearValue() {
    this._direction = "";
    this._structure = "";
    this._classification = "";
    this.nom_prenoms = "";
    this.matricule = "";
  }

  editStatutFicheUser(content, data) {
    this.statutFiche = data.statut;
    this.agentRow = data;
    this.activeModal = this.modalService.
      open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false, centered: true });
  }

  updateStatut(data) {
    this.loadingBar.start();
    const obj = {
      'entretien_id': data?.entretien_id,
      'statut': this.statutFiche
    }
    this.appService.postData(`gestion-evaluations/fiche/change-status`, obj).subscribe(
      (res) => {
        if (res.error === false) {
          this.loadingBar.stop();
          this.activeModal.close();
          swal.fire({
            title: 'HR PERF',
            type: 'success',
            text: res.message,
            showCancelButton: false,
            confirmButtonText: 'ok',
          });
          this.getAllSuiviCampagne();
        } else {
          this.activeModal.close();
          swal.fire({
            title: 'HR PERF',
            type: 'error',
            text: res.message,
            showCancelButton: false,
            confirmButtonText: 'ok',
          });
          this.loadingBar.stop();
        }
      },
      (error) => {
        this.activeModal.close();
        swal.fire({
          title: 'HR PERF',
          type: 'error',
          text: error.error.message,
          showCancelButton: false,
          confirmButtonText: 'ok',
        });
        this.loadingBar.stop();
      }
    );
  }

  exporterFiche() {
    this.loadingBar.start();
    const data = {
      direction_id: this._direction?.id,
      structure: this._structure?.code,
      classification: this._classification?.code,
      nom_prenoms: this.nom_prenoms,
      matricule: this.matricule,
      campagne_id: this.storage.retrieve('idCampagneEiaSelected'),
    }
    this.suiviSce
      .ExportAgents(data)
      .subscribe({
        next: (res: any) => {
          this.loadingBar.stop();
          this.response = res['data'];
          const arrayAgent = [];
          for (let i = 0; i < this.response?.length; i++) {
            arrayAgent.push(
              {
                'Matricule': this.response[i].matricule,
                'Qualité': this.response[i].qualite,
                'Nom': this.response[i].nom,
                'Prénoms': this.response[i].prenoms,
                'Poste': this.response[i].poste,
                'Classification': this.response[i].classification,
                'Categorie': this.response[i].categorie,
                'Direction': this.response[i].direction.code,
                'Structure': this.response[i].structure,
                // 'Section': this.response[i].section.code,
                // 'Sous-section': this.response[i].sous_section.code,
                'Ancienneté poste': this.response[i].anciennete_poste,
                'Ancienneté SIR': this.response[i].anciennete_sir,
                'Ancienneté catégorie': this.response[i].anciennete_cat,
                'Age': this.response[i].age,
                'Statut': this.response[i].statut,
              }
            );
          }
          this.excelService.exportAsExcelFile(arrayAgent, 'suivi_campagne');
          this.loadingBar.stop();
        },
        error: (error) => {
          this.loadingBar.stop();
          this.toastrService.error(error.error.message);
        }
      })
  }

  ouvrirFicheEvaluation(data, type_fiche, type_sauvegarde, category) {
    // tslint:disable-next-line: max-line-length
    this._router.navigateByUrl(`campagne/suivi-eia/agent/${data?.entretien_id}/${data?.agent_id}/type_fiche/${type_fiche}/type_sauvegarde/${type_sauvegarde}/${category}/statut/${data?.statut}`);

  }

  getAllSuiviCampagne() {
    this.loadingBar.start();
    this.appService.getData('campagne/' + this.storage.retrieve('idCampagneEiaSelected') + '/agent/all')
      .subscribe(
        res => {
          if (res.error === false) {
            this.loadingBar.stop();
            this.listSuivi = res.data;
          } else {
            this.loadingBar.stop();
            console.log(res.message);
          }
        }, err => {
          this.loadingBar.stop();
          this.toastrService.error(err.error.message);
        }
      );
  }

  rerender() {
    this.getAllSuiviCampagne();
  }

  tabChange(evt) {
    localStorage.setItem('activeId', evt.nextId)
  }

}
